import { init } from '../tabs-init';

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tabs-component').forEach(init);
});
